import React from 'react'

const Spinner = () => {
  return (
    <div className="flex items-center justify-center min-h-screen bg-secondary-50">
        <div className="relative">
          <div className="animate-spin rounded-full h-16 w-16 border-4 border-primary-200"></div>
          <div className="animate-spin rounded-full h-16 w-16 border-4 border-primary-600 border-t-transparent absolute inset-0"></div>
        </div>
      </div>
  )
}

export default Spinner